import { useFeatureEnabled, Feature } from "@/hooks/useFeatureEnabled";
import { useExperiment } from "@scripts/react/hooks/useExperiment";
import { experiments } from "@rflocal/shared";

const { ExperimentKey } = experiments;

/**
 * Checks if Continuous Improvement is enabled for the current workspace.
 * Returns true if either the feature flag or the PostHog rollout experiment is on.
 */
export const useContinuousImprovementEnabled = (): boolean => {
    const isFeatureEnabled = useFeatureEnabled(Feature.ContinuousImprovement);
    const { enabled: isExperimentEnabled } = useExperiment(
        ExperimentKey.ContinuousImprovementRollout
    );
    return isFeatureEnabled || isExperimentEnabled;
};
